export default __webpack_public_path__ + "player-section-v2.png";